import axios from 'axios';

const baseURL = '/api';
const fieldAttributesURL = '/field_attributes';
const opportunityDataURL = '/opportunities';
const opportunityReplyURL = '/opportunity_replies';

/**
 * Gets all opportunities from an org
 */
export const getOpportunities = (orgID) => {
	return axios
		.get(`${baseURL}${opportunityDataURL}?organization_id=${orgID}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Gets opportunityData about a SINGLE opportunity
 * @param oppID the opportunity that should be found
 */
export const getOpportunity = (oppID) => {
	return axios
		.get(`${baseURL}${opportunityDataURL}/${oppID}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

// http://localhost:3000/api/opportunities/field_defaults is the new set up. Much cleaner
export const getFieldAttributes = () => {
	return axios
		.get(`${baseURL}${opportunityDataURL}${fieldAttributesURL}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
			return undefined;
		});
};

/**
 * Creates an opportunity with the data given and sends it to backend API
 * @param orgID
 * @param opportunityData the opportunity data
 */
export const postOpportunity = (orgID, opportunityData) => {
	// This really should be renamed on the backend..
	if (opportunityData.opportunity_types !== []) {
		opportunityData['opportunity_type_ids'] =
			opportunityData.opportunity_types;
	}
	opportunityData['organization_id'] = orgID;
	return axios
		.post(`${baseURL}${opportunityDataURL}`, opportunityData)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Saves the current opportunity data and sends it to the backend API
 * @param oppID the current opportunity id
 * @param opportunityData the opportunity data
 */
export const putOpportunity = (oppID, opportunityData) => {
	return axios
		.put(`${baseURL}${opportunityDataURL}/${oppID}`, opportunityData)
		.then((response) => {})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Deletes an opportunity
 * @param oppID the current opportunity id
 */
export const deleteOpportunity = (oppID) => {
	return axios
		.delete(`${baseURL}${opportunityDataURL}/${oppID}`)
		.then((response) => {})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Posts the opportunity reply
 * @param oppID the opportunity id
 * @param opportunityReply the reply we are using
 */
export const postOpportunityReply = (oppID, opportunityReply) => {
	return axios
		.post(
			`${baseURL}${opportunityDataURL}/${oppID}${opportunityReplyURL}`,
			opportunityReply
		)
		.then((response) => {})
		.catch((error) => {
			console.error(error);
		});
};
